import Handler from "./handler"
import http from "../../../http"
import { getQuery } from "../xes-lib"

class PlayerHandler extends Handler {
  init(state, dispatch) {
  }
  getProjectData() {
    let id = getQuery('pid',window.defaultPid)
    return http.getProjectById(id)
  }
  static getInstance() {
    if (PlayerHandler.instance === null) {
      PlayerHandler.instance = new PlayerHandler()
    }
    return PlayerHandler.instance
  }
}
PlayerHandler.instance = null

export default PlayerHandler